import { EventEmitter, Injectable } from '@angular/core';
import { ProductInternalResponseDto } from '@scip/api';

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  uploadProductEmitter: EventEmitter<ProductInternalResponseDto> = new EventEmitter();
  productIsUploaded(product: ProductInternalResponseDto): void {
    this.uploadProductEmitter.emit(product);
  }
}
